export default __webpack_public_path__ + "static/media/Sage's Sandals of Yag.2d90ed23.jpg";